import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=5dc9d7e0&scoped=true"
import script from "./validate.vue?vue&type=script&lang=js"
export * from "./validate.vue?vue&type=script&lang=js"
import style0 from "./validate.vue?vue&type=style&index=0&id=5dc9d7e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9d7e0",
  null
  
)

export default component.exports